<div class="flex flex-col">
  <div class="flex flex-col-reverse w-full relative">
    <input
      sag-ui-input
      type="text"
      class="pr-8"
      [disabled]="disabled"
      [required]="invalid || (required && touched)"
      [attr.pattern]="invalid ? 'SAG_INVALID_STATE' : null"
      [placeholder]="placeholder"
      [value]="displayValue"
      (input)="blockChange($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      #input
    />
    <label sag-ui-input-label [htmlFor]="id">
      <span *ngIf="required">*</span>
      {{ label }}
      <span
        *ngIf="hint"
        class="text-[#999999] dark:text-[#666666] icon-circle-information pl-2"
        sag-ui-tooltip
        [tooltip]="hint"
      ></span>
    </label>
    <sag-ui-button
      class="absolute !w-[30px] bottom-[3px] right-[3px] z-[10]"
      style="padding: 0!important;"
      [disabled]="disabled"
      [square]="true"
      (click)="openDialog()"
    >
      <span class="icon-user"></span>
    </sag-ui-button>
  </div>
</div>
